import './styles/main.scss'

import { createPinia } from 'pinia'
import { createApp } from 'vue'

import { useUserStore } from '@/stores/user'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { createAppRouter } from './router'

// Déterminer le mode de l'application selon l'URL
const getAppMode = (): 'candidate' | 'hr' | 'welcome' => {
  const urlParams = new URLSearchParams(window.location.search)
  const mode = urlParams.get('mode')

  if (mode === 'candidate') return 'candidate'
  if (mode === 'hr') return 'hr'

  // Détection basée sur le chemin
  const path = window.location.pathname
  if (path.startsWith('/hr') || path.startsWith('/admin')) return 'hr'
  if (path.startsWith('/candidate') || path.startsWith('/applications') || path.startsWith('/questionnaires')) return 'candidate'

  return 'welcome'
}

const appMode = getAppMode()
const router = createAppRouter(appMode)

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

// Initialiser le store utilisateur selon le mode
const userStore = useUserStore()
if (appMode === 'hr') {
  userStore.setUserType('hr')
} else if (appMode === 'candidate') {
  userStore.setUserType('candidate')
}

app.use(router)
app.use(vuetify)

// Fournir le mode à l'application
app.provide('appMode', appMode)

app.mount('#app')
